export enum OryAuthPages {
  ROOT = 'auth',
  LOGIN = 'login',
  REGISTER = 'register',
  LOGOUT = 'logout',
  OTP = 'otp',
  ERROR = 'error',
  ACCESS_DENIED = 'access-denied',
  NOT_FOUND = 'not-found',
}

export const OryAfterAuthLoginRedirectTo = '/auth-redirect';
export const OryAfterAuthLogoutRedirectTo = '/auth-redirect';
